package io.horion.cv.api.utils

import kotlinx.browser.window

object LocalStorageManager {
    private const val SESSION_UUID_KEY = "sessionUuid"

    fun saveSessionUuid(sessionUuid: String) {
        window.localStorage.setItem(SESSION_UUID_KEY, sessionUuid)
    }

    fun getSessionUuid(): String? {
        return window.localStorage.getItem(SESSION_UUID_KEY)
    }

    fun removeSessionUuid() {
        window.localStorage.removeItem(SESSION_UUID_KEY)
    }
}